import { getOrgBackend } from "../../../../app/backend";
import { useRemoteQuery } from "../../useRemote/useRemoteQuery";

export type PermissionContext = {
  userId: string;
  companyId: number;
  costCenterUnitId: string | null;
  costCenterUnitName: string | null;
};

export function useRemoteFetchPermissionContext(enabled: boolean) {
  return useRemoteQuery<PermissionContext[]>({
    queryKey: ["permission-context"],
    url: `${getOrgBackend()}/user-info/permission-context`,
    enabled
  });
}
